// -----------------------------------------------------------------------------
// Scripts
// -----------------------------------------------------------------------------

var SCRIPTS = SCRIPTS || {};
var isMobileOrTablet;
var isOldBrowser;
var enableAjaxLoading;
var body;
var interact = 'touchstart touchmove scroll mousemove mousedown DOMMouseScroll mousewheel keyup';

$(document).ready(function () {
  body = $('body');
  isMobileOrTablet = (body.data('mobileortablet') == '1' ? true : false);
  isOldBrowser = ($('html').hasClass('ieold') ? true : false);
  enableAjaxLoading = true;
  window.cdnurl = body.data('cdnurl');

  SCRIPTS = {
    settings: {},
    init: function () {
      this.nav.init();
      this.headershrink.init();
      //this.smoothScroll.init();

      $('.lazy').lazy({
        attribute: "data-srcset",
        afterLoad: function (element) {
          element.addClass('lazyloaded');
        }
      });

      if ($('[data-youtube]').length) {
        var ytbgloaded = 1;
        $(document).on(interact, function () {
          enableAjaxLoading = false;

          if (ytbgloaded) {
            ytbgloaded = 0;
            $.ajaxSetup({
              cache: true
            });
            $.getScript(window.cdnurl + "/resources/themes/tripstramps/javascript/ytbg.js", function () {
              enableAjaxLoading = true;
            });
          }
        });
      }

      /*if ($('input.js-datepicker').length > 0) {
          $("input.js-datepicker").datepicker({
              dateFormat: 'd MM yy',
              minDate: +1,
              maxDate: "+1Y"
          });
      }*/

      /*if ($('.js-jawbone').length > 0) {
          this.jawbone.init();
      }*/

      if ($('.js-map').length > 0) {
        this.setupMap.init();
      }

      if ($('.js-mappoints').length > 0) {
        this.setupMapPoints.init();
      }

      if ($('.js-slick').length > 0) {
        this.slick.init();
      }

      if ($('.js-slick-hero').length > 0) {
        this.slickhero.init();
      }

      if ($('.js-slick-featured').length > 0) {
        this.slickfeatured.init();
      }

      if ($('.js-slick-reviews').length > 0) {
        this.slickreviews.init();
      }

      if ($('.js-gallery').length > 0) {
        this.fancybox.init();
      }

      if ($('.js-filterform').length > 0) {
        this.filterform.init();
      }

      if ($('.js-booknowform').length > 0) {
        this.booknowform.init();
      }

      if ($('.js-tabform').length > 0) {
        this.tabform.init();
      }

      if ($('.js-fancyboxbook').length > 0) {
        this.fancyboxbook.init();
      }

      //window.eraseCookie('showsignup');
      if (body.data('signupenabled') == '1') {
        var showsignup = window.getCookie('showsignup');

        if (showsignup != '1') {
          this.fancyboxmailchimp.init();
        }
      }

      if ($('.js-reveal').length > 0) {
        this.reveal.init();
      }

      if ($('.js-comein').length > 0 && !isOldBrowser) {
        window.sr = ScrollReveal({
          reset: false,
          distance: '0',
          scale: .9,
          delay: 50
        });
        sr.reveal('.js-comein');
      }

      if ($('.js-share').length > 0) {
        this.shareSetup.init('');
      }

      if ($('.js-faqs').length > 0) {
        this.faqs.init();
      }

      if ($('.js-parallax').length > 0 && !isMobileOrTablet && !isOldBrowser) {
        this.parallax.init();
      }

      if ($('form:not(.js-norecaptcha)').length > 0) {
        this.formRecaptcha.init();
      }

      $("[data-fancybox]").fancybox({
        padding: 0,
        hash: false,
        autoFocus: true,
        helpers: {
          overlay: {
            closeClick: true, // if true, fancyBox will be closed when user clicks on the overlay
            speedOut: 200, // duration of fadeOut animation
            showEarly: true, // indicates if should be opened immediately or wait until the content is ready
            css: {}, // custom CSS properties
            locked: true // if true, the content will be locked into overlay
          }
        },
        iframe: {
          css: {
            width: '950px'
          }
        },

        touch: {
          vertical: false, // Allow to drag content vertically
          momentum: false // Continue movement after releasing mouse/touch when panning
        }
      });

    },
    parallax: {
      init: function () {
        var _this = this;

        var $parallax = $('.js-parallax img');
        $parallax.css('object-position', '50% 50%');

        $(window).scroll(function () {
          var st = $(this).scrollTop();

          $parallax.css('object-position', '50% calc(50% + ' + (st * .5) + 'px)');

        });
      }
    },
    faqs: {
      init: function () {
        var _this = this;

        $(".js-faqs .faq-content").not('.faq-default').hide();
        $('.js-faqs').find('.faq-toggle').click(function () {

          // Expand or collapse this panel
          $(this).toggleClass('faq-active').next().slideToggle('fast');

          // Remove active class
          $(".faq-toggle").not($(this)).removeClass('faq-active');
          // Hide the other panels
          $(".faq-content").not($(this).next()).slideUp('fast');
        });
      }
    },
    filterform: {
      init: function () {
        var _this = this;
        var $filterform = $('form.js-filterform');
        var $filterfield = $filterform.find("select");

        $filterfield.on('change', function () {
          if ($filterform.hasClass('js-filtersubmitonchange')) {
            $filterform.submit();
          } else {
            var extraslash = '';
            if ($filterfield.data('url').substr(-1) !== '/') {
              extraslash = '/';
            }
            window.location.href = $filterfield.data('url') + extraslash + ($filterfield.val() == '' ? '' : ($filterfield.val().toLowerCase() + '/'));
          }
        });


        if ($filterform.hasClass('filtered')) {
          SCRIPTS.scrollToDiv.init($filterform, 0);
        }


        // $(window).on('load', function () {

        //   if ($filterform.hasClass('filtered')) {
        //     SCRIPTS.scrollToDiv.init($filterform, 0);
        //   }
        // });
      },
    },
    booknowform: {
      init: function () {
        var _this = this;
        var $booknowform = $('form.js-booknowform');

        $booknowform.each(function () {
          var $booknowfield = $(this).find("select");
          $(this).on('submit', function (e) {
            e.preventDefault();

            SCRIPTS.fancyboxbook.open($booknowfield.data('url') + $booknowfield.val() + '?iframe=true');
          });
        });
      },
    },
    tabform: {
      init: function () {
        var _this = this;
        var $tabselect = $("select[name='Tab']");
        var $tabs = $('.js-tab');
        var $tablist = null;

        $tabs.slice(1).hide();

        $tabform = $tabselect.closest('form');

        if ($tabform.hasClass('js-tabdesktop')) {
          var x = 0;
          $tablist = $('<ul>').addClass('tablist');
          $tabselect.find("option").each(function () {
            var val = $(this).val();

            if (val != '') {
              $tablistitem = $('<a>').attr('data-index', val).attr('href', window.location.pathname + '#' + val).text($(this).text()).addClass(x == 0 ? 'active' : '').click(function () {
                $tabselect.val($(this).data('index')).trigger('change');
              });
              $tablist.append($('<li>').append($tablistitem));
            }

            x++;
          });

          $tabform.after($tablist);
        }

        $tabselect.on('change', function () {
          $tabs.hide();

          var tabid = $tabselect.val();

          if (tabid != '') {

            if ($tabform.hasClass('js-scrolltodiv')) {
              SCRIPTS.scrollToDiv.init($('#' + tabid), 0);

            } else {

              if ($tabform.hasClass('js-tabdesktop')) {
                $tablist.find('a').removeClass('active');
                $tablist.find('a[data-index="' + tabid + '"]').addClass('active');
              }

              $("#tab-" + tabid).fadeIn(400, function () {
                if ($(this).find('#mapholder').length > 0) {
                  map.fitBounds(bounds);
                }
              });

              if ($tabform.is(":visible")) {
                SCRIPTS.scrollToDiv.init($tabform, 0);
              }


              $tabselect.blur();

              window.location.hash = tabid;
              //window.history.pushState(url, null, url);
            }
          }
        });

        $(window).on('load', function () {
          if (window.location.hash) {
            var hash = window.location.hash.slice(1);

            if ($("#tab-" + hash).length > 0) {
              $tabselect.val(hash).trigger('change');
            }
          }
        });
      },
    },
    reveal: {
      init: function () {
        var _this = this;
        var $links = $('.js-reveal');
        var $divs = $('.js-reveal').closest('div').find('div.content');
        var $divcurrent = null;

        $divs.hide().each(function () {
          var parent = $(this).parent();
          var close = $('<a>').attr('href', 'javascript:;').addClass('close icon-close');
          $(this).append(close);

          $(this).prepend(parent.find('.js-reveal span.details').clone());

          close.click(function (e) {
            e.preventDefault();

            parent = $(this).parent().parent();
            parent.find('.js-reveal').trigger('click');
            SCRIPTS.scrollToDiv.init(parent, 0);
          });
        });

        $links.click(function (e) {
          e.preventDefault();

          $divs.hide();

          if ($(this).hasClass('active')) {
            $(this).removeClass('active');

            //window.location.hash = '';

            window.history.pushState(null, null, window.location.pathname);

          } else {
            $links.removeClass('active');
            $(this).addClass('active');
            $divcurrent = $(this).closest('div').find('div.content');
            $divcurrent.fadeIn();

            var hash = $(this).data('urlsegment');

            SCRIPTS.scrollToDiv.init($divcurrent, 0);

            window.history.pushState(null, null, window.location.pathname + '#' + hash);
          }
        });

        $(window).on('load', function () {
          if (window.location.hash) {
            var hash = window.location.hash.slice(1);

            $("a[data-urlsegment='" + hash + "']").trigger('click');
          }
        });
      },
    },
    contactform: {
      init: function () {
        var _this = this;
        var $options = $("input[name='Option']");

        _this.otherVisibility($options);

        $options.on('change', function () {
          _this.otherVisibility($options);
        });
      },
      otherVisibility: function ($options) {
        option = $("input[name='Option']:checked").val();
        otherfield = $options.closest('form').find("input[name='Other']").closest('div.field');

        if (option == 'Other') {
          otherfield.removeClass('hidden');
        } else {
          otherfield.addClass('hidden');
        }
      }
    },
    formRecaptcha: {
      loaded: false,
      init: function () {
        var _this = this;

        _this.loadRecaptcha();

        $(window).scroll(function () {
          _this.loadRecaptcha();
        });
      },
      loadRecaptcha: function () {
        var _this = this;

        if (!_this.loaded) {
          $('form:not(.js-norecaptcha):in-viewport').each(function () {
            //console.log('loaded')

            $.ajaxSetup({
              cache: true
            });

            $.getScript(window.cdnurl + "/resources/themes/tripstramps/javascript/NocaptchaField.js");
            _this.loaded = true;
          });
        }
      }
    },
    fancyboxmailchimp: {
      init: function () {
        window.setCookie('showsignup', 1, 365);

        var showsignup = 1;

        $(document).on(interact, function () {
          if (showsignup) {
            showsignup = 0;
            $.fancybox.open({
              src: 'home/signup/',
              type: 'iframe',
              hash: false,
              toolbar: false,
              smallBtn: true,
              autoFocus: true,
              iframe: {
                preload: false,
                css: {
                  width: '490px',
                  padding: '0',
                  margin: '0'
                }
              }
            });
          }
        });
      }
    },
    fancyboxbook: {
      init: function () {
        var _this = this;
        $('.js-fancyboxbook').click(function (event) {
          event.preventDefault();

          _this.open($(this).attr('href'));
        });
      },
      open: function (url) {
        $.fancybox.open({
          src: url,
          type: 'iframe',
          hash: false,
          toolbar: false,
          smallBtn: true,
          autoFocus: true,
          iframe: {
            preload: false,
            css: {
              width: '750px',
              padding: '0',
              margin: '0'
            }
          },
          /*afterClose: function () {
            enableAjaxLoading = false;
            $.ajaxSetup({
              cache: true
            });
            $.getScript("https://tripsandtramps.rezdy.com/pluginJs?script=embedded-cart", function () {
              enableAjaxLoading = true;
            });
          }*/
        });
      }
    },
    fancybox: {
      init: function () {
        var fancybuttons = [
          'slideShow',
          'fullScreen',
          'thumbs',
          'share',
          //'download',
          //'zoom',
          'close'
        ];

        $('.js-gallery a').attr('data-fancybox', 'tt-gallery').fancybox({
          padding: 0,
          buttons: fancybuttons,
          toolbar: true,
          hash: true,
          autoFocus: false,
          helpers: {
            overlay: {
              closeClick: true, // if true, fancyBox will be closed when user clicks on the overlay
              speedOut: 200, // duration of fadeOut animation
              showEarly: true, // indicates if should be opened immediately or wait until the content is ready
              css: {}, // custom CSS properties
              locked: true // if true, the content will be locked into overlay
            }
          }
        });
      }
    },
    shareSetup: {
      init: function (preselector) {
        $(preselector + '.js-share a').click(function (event) {
          event.preventDefault();
          popupWindow = window.open($(this).attr('href'), '_blank', 'location=no,menubar=no,width=600,height=480,toolbar=no,scrollbars=yes,resizable=no');
          popupWindow.focus();
        });
      }
    },
    slick: {
      init: function () {
        $('.js-slick').each(function () {
          var slickitem = $(this);
          var slickid = slickitem.attr('id');
          var slidecount;

          $('#' + slickid).slick({
            lazyLoad: 'progressive',
            dots: false,
            infinite: true,
            arrows: false,
            slidesToShow: 5,
            //centerMode: true,
            variableWidth: true,
            speed: 500,
            responsive: [{
              breakpoint: 1500,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 3
              }
            }
            ]
          });

          slickitem.on('afterChange', function (event, slick, direction) {
            $('#' + slickid).find('.lazy').lazy({
              attribute: "data-srcset",
              afterLoad: function (element) {
                element.addClass('lazyloaded');
              }
            });

          });

          slidecount = slickitem.slick('getSlick').slideCount;

          var next = $('<a>').attr('href', 'javascript:;').addClass('slicknext icon-thin-next');
          $('#' + slickid).append(next);

          next.click(function (event) {
            event.preventDefault();

            if (slickitem.slick('slickCurrentSlide') == (slidecount - 2)) {
              slickitem.slick('slickGoTo', 0);
            } else {
              slickitem.slick('slickNext');
            }
          });
        });
      }
    },
    slickfeatured: {
      init: function () {
        $('.js-slick-featured').slick({
          dots: true,
          infinite: false,
          speed: 500,
          prevArrow: "<a href='javascript:;' class='prev icon-thin-prev'></a>",
          nextArrow: "<a href='javascript:;' class='next icon-thin-next'></a>"
        });
      }
    },
    slickreviews: {
      init: function () {
        $('.js-slick-reviews').slick({
          dots: true,
          infinite: true,
          speed: 500,
          prevArrow: "<a href='javascript:;' class='prev icon-thin-prev'></a>",
          nextArrow: "<a href='javascript:;' class='next icon-thin-next'></a>"
        });
      }
    },
    slickhero: {
      init: function () {
        $('.js-slick-hero').slick({
          dots: false,
          infinite: true,
          arrows: true,
          autoplay: true,
          autoplaySpeed: 6000,
          speed: 500,
          prevArrow: "<a href='javascript:;' class='prev icon-thin-prev'></a>",
          nextArrow: "<a href='javascript:;' class='next icon-thin-next'></a>"
        });
      }
    },
    /*jawbone: {
        init: function() {
            var _this = this;
            $('.js-jawbone').imagesLoaded().done(function() {
                Jawbone.init();
                _this.events();
            });
        },
        events: function() {
            if (window.location.hash) {
                var hash = window.location.hash;
                var item = $('.js-jawbone').find("[data-urlsegment='" + hash + "']");
     
                setTimeout(function() {
                    item.trigger('click');
                }, 1000);
            }
        }
    },*/
    nav: {
      button: $('.js-menu-btn'),
      menu: $('.js-menu'),
      menuscroll: $('.js-menuscroll'),
      menuItems: $('.js-navscrolltosection'),
      lastId: 0,
      topMenuHeight: 1,
      scrollItems: null,
      init: function () {
        var _this = this;
        this.button.attr('href', '#menu').append('<span>').on('click', function (e) {
          e.preventDefault();

          if (_this.button.hasClass('active')) {
            $('body').removeClass('nav-active');
            _this.button.removeClass('active');
            _this.menu.removeClass('mm-menu-active');
          } else {
            $('body').addClass('nav-active');
            _this.button.addClass('active');
            _this.menu.addClass('mm-menu-active');
          }
        });

        var sociallist = $('footer ul.social').html();

        this.menu.mmenu({
          "navbar": false,
          "slidingSubmenus": false,
          "offCanvas": false,
          //"extensions": ["pageshadow", "pagedim-black"],
          "navbars": [{
            "position": "bottom",
            "height": 2,
            "content": [
              sociallist
            ]
          }]
        }, {
          clone: false
        });

        $('#menu').find('li.current, li.section').addClass('mm-listitem_opened mm-menu_selected');
        $('#menu').find('li.current > div.mm-hidden, li.section > div.mm-hidden').removeClass('mm-hidden');
      }
    },
    headershrink: {
      header: $('#header'),
      shrunk: 0,
      init: function () {
        var _this = this;
        //var shrunk = 0;
        this.checkscroll();

        $(window).scroll(function () {
          _this.checkscroll();
        });
      },
      checkscroll: function () {
        var scrolltop = ($(document).scrollTop());

        if (scrolltop > 50 && this.shrunk == 0) {
          this.header.addClass('headershrink');
          this.shrunk = 1;

        } else if (scrolltop <= 50 && this.shrunk == 1) {
          this.header.removeClass('headershrink');
          this.shrunk = 0;
        }
      }
    },
    scrollToDiv: {
      init: function (element, offsetadjust) {
        var headerheight = $('#header').height();
        var scrolltop = ($(document).scrollTop());

        if (offsetadjust == 0) {
          offsetadjust = headerheight;
        }

        if (element == 0) {
          var totalScroll = offset;
        } else {
          var offset = element.offset();
          var totalScroll = (offset.top - offsetadjust);
        }

        var animtime = ((scrolltop - totalScroll) * .5);
        animtime = (animtime < 500 ? 500 : animtime);

        //console.log(animtime);

        $('body,html').animate({
          scrollTop: totalScroll,
          easing: 'easeOutCubic'
        }, animtime);
      }
    },
    /*smoothScroll: {
        button: $('.js-scroll'),
        init: function () {
            this.buttonEvent();
        },
        buttonEvent: function () {
            this.button.on('click', function () {
                if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 600);
                        return false;
                    }
                }
            });
        }
    },*/
    setupMap: {
      init: function () {
        enableAjaxLoading = false;
        $.ajaxSetup({
          cache: true
        });
        $.getScript(window.cdnurl + "/resources/themes/tripstramps/javascript/maps.js?v2", function () {
          $.getScript("//maps.google.com/maps/api/js?key=AIzaSyAgySUjLJ4a25mmf65QC8J-pcKuq6XCGWg&async=2&callback=MapApiLoaded", function () {
            enableAjaxLoading = true;
          });
        });
      }
    },
    setupMapPoints: {
      init: function () {
        enableAjaxLoading = false;
        $.ajaxSetup({
          cache: true
        });
        $.getScript(window.cdnurl + "/resources/themes/tripstramps/javascript/maps.js?v2", function () {
          $.getScript("//maps.google.com/maps/api/js?key=AIzaSyAgySUjLJ4a25mmf65QC8J-pcKuq6XCGWg&async=2&callback=MapPointsApiLoaded", function () {
            enableAjaxLoading = true;
          });
        });
      }
    }
  }

  $(document).ajaxStart(function () {
    if (enableAjaxLoading) {
      $.LoadingOverlay("show", {
        color: "rgba(92, 158, 68, 0.8)",
        image: window.cdnurl + "/resources/themes/tripstramps/images/loadingwhite.gif"
      });
    }
  });
  $(document).ajaxStop(function () {
    if (enableAjaxLoading) {
      $.LoadingOverlay("hide");
    }
  });

  /*
  // Metservice
  $(window).on('load', function () {
    if ($('.fullpagehome').length > 0 && !isMobileOrTablet) {
      $('.fullpagehome').append('<iframe class="weather-widget-iframe vertical" src="https://services.metservice.com/weather-widget/widget?params=white|small|portrait|days-3|classic&loc=te-anau&type=rural" allowtransparency="true"></iframe>');
    }
  });
  */

  SCRIPTS.init();
});

window.setCookie = function (key, value, expiry) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';
}

window.getCookie = function (key) {
  var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
  return keyValue ? keyValue[2] : null;
}

window.eraseCookie = function (key) {
  var keyValue = getCookie(key);
  setCookie(key, keyValue, '-1');
}

var menu = $('.js-menu');
if (menu.length) {

  $('.menu-desk .main > li.haschildren > a').on('click', function (e) {

    if ($(e.target).is('span') !== true) {
      e.preventDefault();

      if ($(e.target).closest('li').hasClass('focused')) {
        $(e.target).closest('li').removeClass('focused');
      } else {
        $('.menu-desk .main > li').removeClass('focused');
        $(e.target).closest('li').addClass('focused');

        $(e.target).closest('li').children('ul').css('padding-left', $(e.target).position().left);
      }
    }
  })

  $('.menu-desk a.schildren').on('click', function (e) {

    if ($(e.target).is('span') !== true) {
      e.preventDefault();

      if ($(e.target).closest('li').hasClass('shown')) {
        $(e.target).closest('li').removeClass('shown');
      } else {
        $('.menu-desk .shown').removeClass('shown');
        $(e.target).closest('li').addClass('shown');

        // $(e.target).closest('li').children('ul').css('padding-left', $(e.target).position().left);
      }
    }

  })
}